import React, { isValidElement } from "react";

import styles from "./DataPanel.module.css";
import { capitalize } from "../utils/string-utils";
import SkeletonLoader from "../ResponseLoader/Skeleton loading/SkeletonLoader";

const DataPanel = ({ data, contrastRow, rowProps, loading = false, wrapValue = false, ValueWrapper }) => {
  if (!Array.isArray(data))
    data = Object.entries(data);

  return (
      <div
          className={[styles.content, contrastRow && styles.contrastRow].join(" ")}
      >
        {data.map(([key, value]) => (
            <DataRow
                property={key}
                key={key}
                value={value}
                rowProps={rowProps}
                loading={loading}
                wrapValue={wrapValue}
                ValueWrapper={ValueWrapper}
            />
        ))}
      </div>
  );
};

const DataRow = ({ property, value, rowProps, loading, wrapValue, ValueWrapper }) => {
  const isObject = typeof value === "object";

  const resolveWrapper = () => {
    if (!ValueWrapper) return null;
    // Component passed directly -> applies to every row
    if (typeof ValueWrapper === "function") return ValueWrapper;
    // Object map -> only applies to the matching property
    return ValueWrapper[property] || null;
  };

  const renderValue = (value) => {
    if (isValidElement(value)) {
      return value;
    }

    const content = (value?.text || value)?.toString() || "--";
    const Wrapper = resolveWrapper();

    if (Wrapper) {
      return <Wrapper>{content}</Wrapper>;
    }

    return <>{content}</>;
  };

  return (
      <div
          {...rowProps}
          className={[styles.infoRow, rowProps?.className].join(" ")}
      >
      <span
          className={styles.infoKey}
          title={capitalize(property).replace(/_/g, " ")}
      >
        {loading ? (
            <SkeletonLoader style={{ width: "100%", height: "25px" }} />
        ) : (
            capitalize(property).replace(/_/g, " ")
        )}
      </span>

        <span
            className={styles.infoValue}
            style={{
              ...(isObject ? { color: value?.color } : {}),
              ...(wrapValue && {
                whiteSpace: "normal",
                wordBreak: "break-word",
              }),
            }}
            title={value}
        >
        {loading ? (
            <SkeletonLoader style={{ width: "100%", height: "25px" }} />
        ) : (
            renderValue(value)
        )}
      </span>
      </div>
  );
};

export default DataPanel;